module.exports = __webpack_public_path__ + "img/影像技术和护理@2x.34d23633.png";